import {
  A11y,
  Keyboard,
  Navigation,
  Pagination,
} from 'swiper';

import Swiper from 'swiper/core/core';

import { header } from 'assets/components';
import { images, niceScroll, scrolling } from 'assets/utilities';

import './hero.scss';

Swiper.use([
  A11y,
  Keyboard,
  Navigation,
  Pagination,
]);

const SELECTOR_HERO = '.js-hero';
const SELECTOR_SLIDER = '.js-heroSlider';
const SELECTOR_MORE = '.js-heroMore';
const INITIAL_STATE = {
  sliders: [],
};
let state = { ...INITIAL_STATE };

const onMoreClick = function onHeroMoreClick(ev) {
  const elHero = ev.currentTarget.closest(SELECTOR_HERO);
  if (!elHero) {
    return;
  }

  const heroBox = elHero.getBoundingClientRect();
  const y = heroBox.bottom - header.getHeight() + scrolling.getScrollY();

  niceScroll.scrollTo({ y, speed: 0.8 });
};

const bind = function bindHero() {
  [].forEach.call(
    document.querySelectorAll(SELECTOR_SLIDER),
    (el) => {
      const swiperInstance = new Swiper(el, {
        loop: true,
        loopedSlides: 3,
        navigation: false,
        pagination: false,
        slideToClickedSlide: true,
        slidesPerView: 'auto',
      });
      swiperInstance.on('slideChange', images.init);
      state.sliders.push(swiperInstance);
    },
  );

  [].forEach.call(
    document.querySelectorAll(SELECTOR_MORE),
    (el) => {
      el.addEventListener('click', onMoreClick);
    },
  );
};

const init = function initHero() {
  bind();
};

const destroy = function destroyHero() {
  [].forEach.call(
    document.querySelectorAll(SELECTOR_MORE),
    (el) => {
      el.addEventListener('remove', onMoreClick);
    },
  );

  state.sliders.forEach((slider) => {
    slider.destroy();
  });
  state = { ...INITIAL_STATE };
};

export default {
  destroy,
  init,
};
